import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../store';

export const selectTags = (state: RootState) => state.tags;

export const selectTagList = createSelector(selectTags, (tags) => tags.tags);
